import React, { memo } from "react";
import {
  CheckboxProps,
  FormControlLabel,
  FormGroup,
  Checkbox as MuiCheckbox,
  styled,
} from "@mui/material";
import { BORDER_COLORS, CHECKBOX_COLORS, FONT_COLORS } from "../../constants";

const UnCheckedIconCustom = styled("span")(() => ({
  width: "18px",
  height: "18px",
  borderRadius: "4px",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: CHECKBOX_COLORS.uncheckedBorderColor,
  boxShadow: "none",
  backgroundColor: CHECKBOX_COLORS.uncheckedBackgroundColor,
  ".Mui-focusVisible &": {
    outline: BORDER_COLORS.default,
    outlineOffset: 2,
  },
  "input:hover ~ &": {
    backgroundColor: CHECKBOX_COLORS.hoverBackgroundColor,
  },
}));

const CheckedIconCustom = styled(UnCheckedIconCustom)({
  backgroundColor: CHECKBOX_COLORS.checkedBackgroundColor,
  borderColor: CHECKBOX_COLORS.checkedBorderColor,
  "&:before": {
    width: "16px",
    height: "16px",
    display: "block",
    backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23${CHECKBOX_COLORS.checkedShapeColor.slice(
      1,
    )}'/%3E%3C/svg%3E")`,
    content: '""',
  },
  "input:hover ~ &": {
    backgroundColor: CHECKBOX_COLORS.hoverBackgroundColor,
  },
});

interface ICheckboxProps extends CheckboxProps {
  label?: string;
}

export const Checkbox: React.FC<ICheckboxProps> = ({ label, ...props }) => {
  return (
    <FormControlLabel
      key={`checkbox-label-${label}`}
      label={label}
      control={
        <MuiCheckbox
          key={`checkbox-${label}`}
          sx={{
            padding: "0 4px 0 0",
          }}
          {...props}
          checkedIcon={<CheckedIconCustom />}
          icon={<UnCheckedIconCustom />}
          disableRipple
          disableFocusRipple
          disableTouchRipple
        />
      }
      sx={{
        margin: 0,
        padding: 0,
        "& .MuiFormControlLabel-label": {
          color: FONT_COLORS.default,
          fontSize: "12px",
          lineHeight: "18px",
          fontWeight: 500,
        },
      }}
    />
  );
};

export default memo(Checkbox);
